<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 py-2>
        <entity-user-list
          ref="president"
          :entity-id="entityId"
          type-role="president"
          :title="$tc('titles.global.president', 2)"
          @form="setOne"
        />
      </v-flex>
      <v-flex xs12 py-2>
        <entity-user-list
          ref="coordinator"
          :entity-id="entityId"
          type-role="coordinator"
          :title="$tc('titles.global.coordinator', 2)"
          @form="setOne"
          @bulkCreate="bulkCreate('coordinator')"
        />
      </v-flex>
      <v-flex xs12 py-2>
        <entity-user-list
          :entity-id="entityId"
          :only-record-roles="true"
          :title="$t('titles.users.onlyRecordRoles')"
          @form="setOne"
          @updateData="setUpdateTable"
        />
      </v-flex>
      <v-flex xs12 py-2>
        <entity-user-list
          ref="trainer"
          :entity-id="entityId"
          type-role="trainer"
          :title="$tc('titles.global.trainer', 2)"
          @form="setOne"
          @bulkCreate="bulkCreate('trainer')"
        />
      </v-flex>
      <v-flex xs12 py-2>
        <entity-user-list
          ref="player"
          :entity-id="entityId"
          type-role="player"
          :title="$tc('titles.global.player', 2)"
          @form="setOne"
          @import="() => (dialogImport = true)"
          @bulkCreate="bulkCreate('player')"
        />
      </v-flex>
      <v-flex xs12 py-2>
        <entity-user-list
          ref="familiar"
          :entity-id="entityId"
          type-role="familiar"
          :title="$tc('titles.global.familiar', 2)"
          @form="setOne"
        />
      </v-flex>
    </v-layout>
    <user-form
      v-if="dialogUser"
      ref="form"
      :dialog="dialogUser"
      :type-role="typeRole"
      :entity-id="entityId"
      @close="closeDialogUserModal"
    />
    <dialog-import-users
      v-if="dialogImport"
      :entity-id="entityId"
      @close="dialogImport = false"
    />
    <DialogBulkCreateUsers
      v-model="dialogBulkCreate"
      :type-role="typeRole"
      :entity-id="entityId"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EntityUserList from './components/EntityUserList.vue'
import UserForm from '@/components/management/users/FormManager.vue'
import DialogBulkCreateUsers from '@/components/widgets/dialog/DialogBulkCreateUsers.vue'
import DialogImportUsers from '@/components/widgets/dialog/DialogImportUsers.vue'
export default {
  name: 'EntityUsers',
  components: {
    EntityUserList,
    UserForm,
    DialogImportUsers,
    DialogBulkCreateUsers,
  },
  props: {
    entityId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialogUser: false,
      dialogImport: false,
      dialogBulkCreate: false,
      typeRole: '',
    }
  },
  methods: {
    ...mapActions({
      fetchOne: 'users/fetchOne',
      reset: 'users/reset',
      fetchUserRoles: 'users/fetchUserRoles',
      fetchUserFollowings: 'users/fetchUserFollowings',
      fetchUserSubscriptions: 'users/fetchUserSubscriptions',
      fetchRoles: 'roles/fetchSelectList',
    }),
    async setOne({ id, typeRole }) {
      this.typeRole = typeRole
      this.reset()
      if (id) {
        await this.fetchOne(id)
        this.fetchUserRoles(id)
        this.fetchUserFollowings(id)
        this.fetchUserSubscriptions(id)
      }
      this.dialogUser = true
    },
    bulkCreate(typeRole) {
      this.typeRole = typeRole
      this.dialogBulkCreate = true
    },
    setUpdateTable(value) {
      if (this.$refs[value] && typeof this.$refs[value].init === 'function') {
        this.$refs[value].init()
      }
    },
    closeDialogUserModal() {
      this.dialogUser = false
      this.reloadAllTables()
    },
    reloadAllTables() {
      Object.keys(this.$refs).forEach((refName) => this.setUpdateTable(refName))
    },
  },
  mounted() {
    this.fetchRoles()
  },
}
</script>
